import React from 'react'
import EffectivenessReportDateRangeSearch from '../components/EffectivenessReportDateRangeSearch'

export default function ReportEffectivenessMobileDateRangeSearch({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  maxDateStr,
  onSearch
}) {
  return (
    <EffectivenessReportDateRangeSearch
      startDate={startDate}
      endDate={endDate}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      maxDate={maxDateStr}
      onSearch={onSearch}
      direction="column"
      applyDatesOnSearchOnly
    />
  )
}
